// @flow
import React from 'react';

export type LDJSONStructuredDataType = {
  dateModified?: ?string,
  datePublished?: ?string,
};

const LDJSONStructuredData = (props: LDJSONStructuredDataType) => {
  const { dateModified, datePublished } = props;
  const data = {
    '@schema': 'http://schema.org',
    '@type': 'WebPage',
    dateModified,
    datePublished,
  };
  return (
    <script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      type="application/ld+json"
    />
  );
};

export default LDJSONStructuredData;
